function formatFilterValue(value) {
  if (Array.isArray(value)) {
    return value
      .map((item) => String(item ?? '').trim())
      .filter(Boolean)
      .join(', ');
  }

  if (typeof value === 'boolean') {
    return value ? 'Sí' : 'No';
  }

  return String(value ?? '').trim();
}

export default function ActiveFiltersLegend({
  items = [],
  emptyText = 'Sin filtros activos.',
  className = '',
}) {
  const normalized = (items || [])
    .map((item) => ({
      label: item?.label || '',
      value: formatFilterValue(item?.value),
    }))
    .filter((item) => item.label && item.value);

  return (
    <div
      className={`crm-active-filters ${normalized.length === 0 ? 'is-empty' : ''} ${className}`.trim()}
      aria-live='polite'
    >
      <span className='crm-active-filters-label'>Filtros activos</span>
      {normalized.length ? (
        <div className='crm-active-filters-list'>
          {normalized.map((item) => (
            <span key={`${item.label}-${item.value}`} className='crm-active-filter-chip'>
              <strong>{item.label}:</strong> {item.value}
            </span>
          ))}
        </div>
      ) : (
        <span className='crm-active-filters-empty'>{emptyText}</span>
      )}
    </div>
  );
}
